import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function getAllEmailTemplates() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllEmailTemplate`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function userNotification() {
    try {
        const response = await getAxiosInstance().get(`/userNotification`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findRecivedEmailActivityByUser() {
    try {
        const response = await getAxiosInstance().get(`/findRecivedEmailActivityByUser`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function emailTemplateAccessUpadet(templateId, action, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/enableOrDisableEmailTemplate/${templateId}/${action}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function notificationStatus(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/notification/status/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    getAllEmailTemplates,
    emailTemplateAccessUpadet,
    userNotification,
    notificationStatus,
    findRecivedEmailActivityByUser
}